import WicodeVertical from "./components/WicodeVertical";
import Vision from "./components/Vision";
import Founders from "./components/Founders";
import BasePage from "../../components/layout/BasePage";
import { useQuery } from "@tanstack/react-query";
import { getAboutUs } from "./api/apiCalls";
import Loading from "../../components/common/Loading";
import BaseHeadline from "../../components/general/BaseHeadline";
import BaseSecondaryHero from "../../components/layout/BaseSecondaryHero";
import BaseScreenImage from "../../components/general/BaseScreenImage";
import AboutIntro from "./components/AboutIntro";
import Values from "./components/Values";
import ContactCTA from "../../components/common/ContactCTA";

function About() {
  
  const { data: aboutData, isLoading: aboutDataLoading } = useQuery({
    queryKey: ["about-us"],
    queryFn: getAboutUs,
  });

  console.log(aboutData);

  if (aboutDataLoading || !aboutData) {
    return <Loading />;
  }

  return (
    <BasePage>
      <BaseSecondaryHero heading={aboutData.hero} />
      <AboutIntro heading={aboutData.introHeading} cards={aboutData.introCards} />
      <BaseScreenImage url={aboutData.teamImage.data.attributes.url} alt="Team" />
      <Vision {...aboutData} />
      <BaseHeadline headline="Welche Probleme gehen wir an?" classProps="lg:hidden pl-4" />
      <WicodeVertical {...aboutData} />
      <Founders {...aboutData} />
      <Values heading={aboutData.valueHeading} values={aboutData.values} />
      <ContactCTA />
    </BasePage>
  );
}

export default About;
